module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-md-6\" style=\"padding-top:5px;\">\r\n        <input type=\"checkbox\" id=\"showHeader\" name=\"showHeader\"  /> Show header\r\n    </div>\r\n    <div class=\"col-md-6 nopadding-r\">\r\n        Height <input type=\"number\" id=\"headerHeight\" name=\"headerHeight\" value=\"")
    ; __append(escapeFn( headerHeight ))
    ; __append("\" style=\"width: 45px;\"> px\r\n    </div>\r\n    <div class=\"col-md-12 form-group-flex\">\r\n        <input type=\"checkbox\" id=\"showButtons\" name=\"buttons\" class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\"> Show buttons</label>\r\n    </div>\r\n    <div class=\"col-md-12 form-group-flex\">\r\n        <input type=\"checkbox\" id=\"resizableColumns\" name=\"allowColumnResize\" class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\">Resizable columns</label> \r\n    </div>\r\n    <div class=\"col-md-12 form-group-flex\">\r\n        <input type=\"checkbox\" id=\"showFooter\" name=\"showFooter\" class=\"form-radio-group\" />\r\n        <label class=\"form-group-label\">Show footer</label>\r\n    </div>\r\n</div>")
  }
  return __output;

}